export const selectTrendingArticles = (state) => state.trending.all || [];
export const selectIsLoading = (state) => state.trending.isLoading;
